import { Component, OnInit, ViewContainerRef, OnDestroy, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { InventoryService } from '../inventory.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Piece } from '../piece';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { SettingsService } from '../../../shared/services/settings.service';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-inventory-pieces',
  templateUrl: './inventory-pieces.component.html',
  styleUrls: ['./inventory-pieces.component.scss']
})
export class InventoryPiecesComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: Piece[];
  _branch_name: string;
  _collection_name: string;
  _design_name: string;
  _color_name: string;


  subscription: Subscription = new Subscription();
  totalPiecesCount: number = 0;
  totalLengthValue: number = 0;
  totalWeightValue: number = 0;
  branchId: number = 0;
  colorId: number = 0;



  columns: ITdDataTableColumn[] = [
    { name: 'piece_number', label: 'Piece #' },
    { name: 'lot_number', label: 'Lot #' },
    { name: 'grade_code', label: 'Grade' },
    { name: 'length', label: 'Length (M)' },
    { name: 'weight', label: 'Weight (Kg)' },
    { name: 'branch_code', label: 'Branch' },
    { name: 'location_name', label: 'Location' }
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  pageSize: number = 50;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  constructor(private _dataTableService: TdDataTableService,
    private _settingsService: SettingsService,
    private _dialogService: TdDialogService,
    private _inventoryService: InventoryService,
    private _viewContainerRef: ViewContainerRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this.presetSearchBox();

    this.route.params.subscribe(
      params => {
        this.branchId = params['branch_id'];
        this.colorId = params['color_id'];
      }
    )

    console.log("Loading pieces for branch ID:" + this.branchId + ", color id:" + this.colorId);

    this.subscription = this._inventoryService.getPieces(this.branchId, this.colorId)
    .subscribe((pieces: Piece[]) => {


      if (Array.isArray(pieces)) {
        this.data = pieces;
        this._branch_name = pieces[0].branch_code + " - " + pieces[0].branch_name;
        this._collection_name = pieces[0].collection_name;
        this._design_name = pieces[0].design_name;
        this._color_name = pieces[0].color_name;

      } else {
        this.data = new Array<Piece>();
      }
      
      this.filteredData = this.data;
      this.filteredTotal = this.data.length;
      this.selectedRows = this.filteredData;
      this.filter();
      this.totalPiecesCount = this.data.length;
      this.totalLengthValue = this.data.reduce((acc, el) => acc + +el.length, 0);
      this.totalWeightValue = this.data.reduce((acc, el) => acc + +el.weight, 0);

      
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('inventory_pieces')) {
      this._searchBox.value = this._settingsService.getSearchTerm('inventory_pieces');
      this._searchBox.searchClicked();
    }
  }

sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;
    this.sortBy = sortEvent.name;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('inventory_pieces', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this.pageSize = pagingEvent.pageSize;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('inventory_pieces'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this.pageSize);
    this.filteredData = newData;
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/inventory/inventory-pieces/inventory-pieces.component.ts